module.exports = __webpack_public_path__ + "img/lonceng.be1b0a56.svg";